export const BASE_URL = 'https://api.jobboard.tedbree.com/v1';
